import { FileDown, Scale } from 'lucide-react'
import { useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import api from '../../../config/AxiosInstance'
import * as Common from '../../../utils/Common'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import './style.css'
import { convertDateWithTime } from '../../../helpers/constants'

const veticalLine = {
  borderLeft: '3px #E0E0E0 solid',
  height: '50px',
  width: '0px',
  marginLeft: '6px'
}

const circle = {
  width: '15px',
  height: '15px',
  background: '#E0E0E0',
  borderRadius: '50%',
  marginTop: '5px'
}

const titleHistory = {
  color: '#828282'
}

const ModalPrDetailTimeline = (props) => {
  const { datahistory, detailinbounds, loadingPrTimeline } = props
  const navigate = useNavigate()
  const [loadingFile, setLoadingFile] = useState({
    armada: false,
    material: false,
    goodReceipt: false
  })

  const normalizedStatus =
    {
      pnp: 'put_away',
      rnr: 'receiving_progress',
      request_pnp: 'waiting_om',
      revised: 'waiting_rnr'
    }[detailinbounds?.status] || detailinbounds?.status

  const handleDownloadArmada = async () => {
    try {
      setLoadingFile((prev) => ({ ...prev, armada: true }))
      const res = await api.get(
        `/inbound/pr-draft/${detailinbounds?.id}/download-armada`,
        {
          responseType: 'arraybuffer'
        }
      )
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-armada-${detailinbounds?.id}.pdf`
        )
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingFile((prev) => ({ ...prev, armada: false }))
    }
  }

  const handleDownloadMaterial = async () => {
    try {
      setLoadingFile((prev) => ({ ...prev, material: true }))
      const res = await api.get(
        `/inbound/pr-draft/${detailinbounds?.id}/download-material`,
        {
          responseType: 'arraybuffer'
        }
      )
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-material-${detailinbounds?.id}.pdf`
        )
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingFile((prev) => ({ ...prev, material: false }))
    }
  }

  const handleDownloadGoodReceipt = async () => {
    try {
      setLoadingFile((prev) => ({ ...prev, goodReceipt: true }))
      const res = await api.get(
        `/inbound/pr-draft/${detailinbounds?.id}/download-good-receipt`,
        {
          responseType: 'arraybuffer'
        }
      )
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-goodsreceipt-${detailinbounds?.id}.pdf`
        )
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingFile((prev) => ({ ...prev, goodReceipt: false }))
    }
  }

  return (
    <Modal {...props} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <small>{detailinbounds.ticket}</small>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loadingPrTimeline && (
          <>
            <Row className="mt-3">
              <Col md={3}>
                <h4>
                  {detailinbounds?.vehicle?.plate_no ?? detailinbounds?.vehicle}
                </h4>
              </Col>
              <Col md={9}>
                <div className="d-flex align-items-center h-100">
                  {normalizedStatus === 'put_away' ? (
                    <>
                      <Col md={12} style={{ fontSize: '14px' }}>
                        <li>
                          Put Away by{' '}
                          {datahistory?.data?.inbound?.action?.pnp?.name ===
                          null ? (
                            <text style={{ color: '#F89D1D' }}>---</text>
                          ) : (
                            <text style={{ color: '#F89D1D' }}>
                              {datahistory?.data?.inbound?.action?.pnp?.name}
                            </text>
                          )}
                        </li>
                      </Col>
                    </>
                  ) : normalizedStatus === 'waiting_om' ||
                    normalizedStatus === 'waiting_pnp' ? (
                    <>
                      <Col md={12} style={{ fontSize: '14px' }}>
                        <li>
                          {normalizedStatus === 'waiting_om'
                            ? 'Waiting OM'
                            : 'Waiting PNP'}
                        </li>
                      </Col>
                    </>
                  ) : normalizedStatus === 'receiving_progress' ? (
                    <>
                      <Col md={12} style={{ fontSize: '14px' }}>
                        <li>
                          Receiving By{' '}
                          {datahistory?.data?.inbound?.action?.rnr?.name ===
                          null ? (
                            <text style={{ color: '#F89D1D' }}>---</text>
                          ) : (
                            <text style={{ color: '#F89D1D' }}>
                              {datahistory?.data?.inbound?.action?.rnr?.name}
                            </text>
                          )}
                        </li>
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col md={12} style={{ fontSize: '14px' }}>
                        <li>
                          {normalizedStatus === 'waiting_rnr'
                            ? 'Waiting RnR'
                            : firstLetterUpperCase(normalizedStatus)}
                        </li>
                      </Col>
                    </>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={12} style={{ marginLeft: '-1rem' }}>
                <div className="d-flex flex-row gap-1">
                  {[
                    'receiving_progress',
                    'waiting_om',
                    'put_away',
                    'waiting_pnp',
                    'done'
                  ].includes(normalizedStatus) && (
                    <Button
                      variant="transparent"
                      onClick={() => handleDownloadArmada()}
                      style={{ cursor: 'pointer' }}
                    >
                      <FileDown className="text-warning" size={24} />
                      <small
                        style={{
                          fontSize: '14px',
                          marginRight: '20px',
                          marginLeft: '10px',
                          cursor: 'pointer'
                        }}
                      >
                        {!loadingFile.armada
                          ? 'Checklist Armada'
                          : 'Downloading...'}
                      </small>
                    </Button>
                  )}
                  {['waiting_om', 'put_away', 'waiting_pnp', 'done'].includes(
                    normalizedStatus
                  ) && (
                    <Button
                      variant="transparent"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDownloadMaterial()}
                    >
                      <FileDown className="text-warning" size={24} />
                      <small
                        style={{
                          fontSize: '14px',
                          marginRight: '20px',
                          marginLeft: '10px'
                        }}
                      >
                        {!loadingFile.material
                          ? 'Checklist Materials'
                          : 'Downloading...'}
                      </small>
                    </Button>
                  )}
                  {[
                    'receiving_progress',
                    'waiting_om',
                    'waiting_pnp',
                    'put_away',
                    'done'
                  ].includes(normalizedStatus) && (
                    <Button
                      variant="transparent"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleDownloadGoodReceipt()}
                    >
                      <FileDown className="text-warning" size={24} />
                      <small
                        style={{
                          fontSize: '14px',
                          marginRight: '20px',
                          marginLeft: '10px'
                        }}
                      >
                        {!loadingFile.goodReceipt
                          ? ' Goods Receipt'
                          : 'Downloading...'}
                      </small>
                    </Button>
                  )}
                  <Button
                    variant="transparent"
                    onClick={() =>
                      navigate(
                        `/inbound/purchase-receipt/sampling/${detailinbounds.id}`,
                        {
                          state: { ticket: detailinbounds.ticket }
                        }
                      )
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    <Scale className="text-dark" size={24} />
                    <small
                      style={{
                        fontSize: '14px',
                        marginRight: '20px',
                        marginLeft: '10px',
                        cursor: 'pointer'
                      }}
                    >
                      Sampling Timbang
                    </small>
                  </Button>
                </div>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={1} className="text-center">
                {datahistory?.data?.histories.map((data, i) => (
                  <div key={i} style={{ marginTop: '-4px' }}>
                    <div style={circle} />
                    <div style={veticalLine} />
                  </div>
                ))}
              </Col>
              <Col>
                {datahistory?.data?.histories.map((data, i) => {
                  return (
                    <div key={i} className="mb-4">
                      <h5 style={titleHistory}>
                        {convertDateWithTime(data.createdAt)}
                      </h5>
                      <h5 style={titleHistory}>
                        <small style={{ fontSize: '14px', marginRight: '5px' }}>
                          {data.notes}
                        </small>
                      </h5>
                    </div>
                  )
                })}
              </Col>
            </Row>
          </>
        )}
        {loadingPrTimeline && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: '100px' }}
          >
            <div className="spinner-border text-warning mb-0" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ModalPrDetailTimeline
